.shell,
.boot {
  --shell-rail-width: 244px;
  --shell-local-header-height: 64px;
  --shell-dock-height: 72px;
  --shell-safe-top: env(safe-area-inset-top, 0px);
  --shell-safe-right: env(safe-area-inset-right, 0px);
  --shell-safe-bottom: env(safe-area-inset-bottom, 0px);
  --shell-safe-left: env(safe-area-inset-left, 0px);
}

.shell {
  display: grid;
  grid-template-columns: var(--shell-rail-width) minmax(0, 1fr);
  min-width: 0;
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--color-canvas);
  color: var(--color-text-body);
}
.shell[data-navigation-collapsed="true"] {
  grid-template-columns: minmax(0, 1fr);
}

.shell[data-navigation-collapsed="true"] .rail {
  display: none;
}

@media (min-width: 901px) {
  .shell {
    transition: grid-template-columns var(--motion-duration-disclosure) var(--motion-easing-standard);
  }

  .shell[data-navigation-collapsed="true"] .main {
    padding-block-start: calc(var(--target-min) + var(--space-2));
  }
}

.rail {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: 100vh;
  height: 100dvh;
  padding: max(20px, var(--shell-safe-top)) 14px max(16px, var(--shell-safe-bottom));
  padding-inline-start: max(14px, var(--shell-safe-left));
  border-inline-end: 1px solid var(--color-hairline);
  background: var(--color-surface);
}
.railHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-1);
  min-width: 0;
}

.brand,
.mobileBrand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: var(--target-min);
  color: var(--color-text-primary);
  font-size: 1.0625rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  text-decoration: none;
}

.brand {
  min-width: 0;
  flex: 1 1 auto;
  padding-inline: 4px;
}
.brand span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand > svg,
.mobileBrand > svg {
  width: 32px;
  height: 32px;
  padding: 6px;
  border-radius: 10px;
  background: var(--color-accent);
  color: #fff;
}

.workspaceCompact,
.workspaceControl {
  display: grid;
  gap: 6px;
}

.workspaceCompact {
  margin-block: 20px 22px;
  padding-inline: 6px;
}

.workspaceCompact label,
.workspaceControl label,
.eyebrow {
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.085em;
  text-transform: uppercase;
}

.workspaceCompact select,
.workspaceControl select,
.field select {
  min-width: 0;
  min-height: var(--target-min);
  padding-inline: 12px 36px;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}

.workspaceCompact select:hover,
.workspaceControl select:hover,
.field select:hover {
  border-color: var(--color-boundary);
}

.workspaceEmpty {
  margin: var(--space-3) 6px;
  color: var(--color-text-secondary);
}
.readinessSummary {
  display: grid;
  gap: 2px;
  margin: 0 6px var(--space-2);
  padding: 8px 10px;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
}

.readinessSummary span {
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.readinessSummary strong {
  color: var(--color-text-primary);
  font-size: 0.8125rem;
}
.searchButton {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  min-width: 0;
  min-height: var(--target-min);
  margin: 0 6px var(--space-2);
  padding-inline: 10px;
  border: 1px solid var(--color-boundary);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 700;
  text-align: start;
  cursor: pointer;
}

.searchButton:hover {
  border-color: var(--color-accent);
  background: var(--color-accent-subtle);
}

.searchButton span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchButton kbd {
  margin-inline-start: auto;
  padding: 2px 5px;
  border: 1px solid var(--color-hairline);
  border-radius: 4px;
  color: var(--color-text-tertiary);
  font-size: 0.6875rem;
  font-weight: 650;
  white-space: nowrap;
}

.mobileSearchButton {
  display: none;
}

.navigation {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.navLink {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: var(--target-min);
  padding-inline: 12px;
  border: 1px solid transparent;
  border-radius: var(--radius-control);
  color: var(--color-text-secondary);
  font-size: 0.9375rem;
  font-weight: 600;
  text-decoration: none;
}

.navLink:hover {
  background: var(--color-surface-raised);
  color: var(--color-text-primary);
}

.navLink[data-active="true"] {
  background: var(--color-accent-subtle);
  color: var(--color-accent);
  font-weight: 750;
}

.navLink[data-active="true"]::before {
  position: absolute;
  inset-block: 10px;
  inset-inline-start: -5px;
  width: 3px;
  border-radius: 999px;
  background: var(--color-accent);
  content: "";
}

.railBottom {
  display: grid;
  gap: 8px;
  min-width: 0;
  margin-block-start: auto;
}

.navigationToggle,
.desktopNavigationToggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-1);
  min-height: var(--target-min);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.navigationToggle {
  flex: 0 0 auto;
  width: var(--target-min);
  padding: 0;
  border-color: transparent;
  background: transparent;
}

.desktopNavigationToggle {
  position: fixed;
  z-index: 5;
  inset-block-start: max(var(--space-1), var(--shell-safe-top));
  inset-inline-start: max(var(--space-1), var(--shell-safe-left));
  padding-inline: var(--space-1) var(--space-2);
  box-shadow: var(--shadow-surface);
}

.navigationToggle:hover,
.desktopNavigationToggle:hover {
  border-color: var(--color-boundary);
  background: var(--color-surface-raised);
}

.accountButton,
.iconButton,
.secondaryButton,
.bootError button {
  min-height: var(--target-min);
  border-radius: var(--radius-control);
  font: inherit;
  cursor: pointer;
}

.accountButton {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--color-text-primary);
  text-align: start;
}

.accountButton:hover {
  border-color: var(--color-hairline);
  background: var(--color-surface-raised);
}

.accountButton > svg:first-child {
  width: 34px;
  height: 34px;
  padding: 7px;
  border-radius: 999px;
  background: var(--color-recessed);
  color: var(--color-accent);
}

.accountButton span {
  display: grid;
  min-width: 0;
}

.accountButton strong,
.accountButton small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.accountButton small {
  color: var(--color-text-secondary);
  font-weight: 400;
}

.accountButton:disabled,
.secondaryButton:disabled,
.field select:disabled,
.toggleField input:disabled {
  color: var(--color-text-tertiary);
  cursor: not-allowed;
}

.main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding: var(--space-4);
  background: var(--color-canvas);
  color: var(--color-text-body);
}

.page {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
.simulationNotice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-block-end: var(--space-3);
  padding: var(--space-1) var(--space-2);
  border-block: 1px solid var(--color-warning);
  border-inline-start: 3px solid var(--color-warning);
  background: var(--color-warning-subtle);
}

.simulationNoticeCopy {
  display: grid;
  flex: 1 1 16rem;
  gap: var(--space-1);
  min-width: 0;
}

.simulationNoticeCopy strong {
  color: var(--color-warning);
}

.simulationNoticeCopy span {
  overflow-wrap: anywhere;
  color: var(--color-text-body);
  font-size: 0.875rem;
}

.simulationExitButton {
  min-height: var(--target-min);
  padding-inline: var(--space-1);
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-control);
  background: var(--color-surface);
  color: var(--color-warning);
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}

.simulationExitButton:hover {
  background: var(--color-surface-raised);
}

.simulationExitButton:disabled {
  color: var(--color-text-tertiary);
  cursor: not-allowed;
}

.main :where(h1, h2, h3) {
  color: var(--color-text-primary);
}

.mobileHeader,
.mobileDock {
  display: none;
}
.mobileWorkspace {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 1px;
}

.mobileWorkspace span {
  overflow: hidden;
  color: var(--color-text-tertiary);
  font-size: 0.625rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  line-height: 1.1;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.mobileWorkspace strong {
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 0.8125rem;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settingsSheet {
  width: min(680px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  margin: auto;
  padding: 0 0 var(--space-3);
  overflow: auto;
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-overlay);
  background: var(--color-surface);
  color: var(--color-text-body);
  box-shadow: var(--shadow-overlay);
}

.settingsSheet::backdrop {
  background: rgb(23 26 43 / 38%);
}

.sheetHeader {
  position: sticky;
  z-index: 1;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  min-height: 76px;
  padding: var(--space-2) var(--space-3);
  border-block-end: 1px solid var(--color-hairline);
  background: var(--color-surface);
}

.sheetHeader h2,
.sheetHeader p {
  margin: 0;
}

.sheetHeader h2 {
  color: var(--color-text-primary);
  font-size: 1.5rem;
  letter-spacing: -0.025em;
}

.iconButton {
  display: inline-grid;
  place-items: center;
  min-width: var(--target-min);
  padding: 0;
  border: 1px solid var(--color-hairline);
  background: var(--color-surface);
  color: var(--color-text-primary);
}

.iconButton:hover,
.secondaryButton:hover {
  border-color: var(--color-boundary);
  background: var(--color-surface-raised);
}

.settingsSection,
.simulationPanel,
.sheetFooter {
  margin-inline: var(--space-3);
}

.settingsSection {
  padding-block: var(--space-3);
  border-block-end: 1px solid var(--color-hairline);
}

.settingsSection h3,
.simulationPanel h3 {
  margin: 0 0 var(--space-2);
  color: var(--color-text-primary);
  font-size: 1.0625rem;
}

.simulationPanel {
  margin-block-start: var(--space-3);
  padding: var(--space-2);
  border: 1px solid var(--color-warning);
  border-radius: var(--radius-surface);
  background: var(--color-warning-subtle);
}

.simulationPanel p {
  margin-block: 0 var(--space-2);
}

.secondaryButton,
.bootError button {
  padding-inline: var(--space-2);
  border: 1px solid var(--color-boundary);
  background: var(--color-surface);
  color: var(--color-text-primary);
  font-weight: 700;
}

.definitionList {
  display: grid;
  gap: var(--space-1);
  margin: 0;
}

.definitionList div {
  display: flex;
  justify-content: space-between;
  gap: var(--space-2);
  padding: 12px var(--space-2);
  border-radius: var(--radius-control);
  background: var(--color-surface-raised);
}

.definitionList dt {
  color: var(--color-text-secondary);
}

.definitionList dd {
  margin: 0;
  color: var(--color-text-primary);
  font-weight: 650;
  text-align: end;
  overflow-wrap: anywhere;
}

.readinessDetail {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-2);
  border: 1px solid var(--color-hairline);
  border-radius: var(--radius-surface);
  background: var(--color-surface-raised);
}

.readinessDetail p {
  margin: 0;
}

.secondaryText {
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.field {
  display: grid;
  gap: var(--space-1);
  color: var(--color-text-primary);
  font-weight: 650;
}

.toggleField {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  min-height: var(--target-min);
  margin-block-start: var(--space-2);
  color: var(--color-text-primary);
}

.toggleField span {
  display: grid;
}

.toggleField small {
  color: var(--color-text-secondary);
  font-weight: 400;
}

.toggleField input {
  width: 22px;
  min-width: 22px;
  height: 22px;
  margin: 0;
  accent-color: var(--color-accent);
}

.inlineError {
  margin-block: var(--space-2) 0;
  padding: var(--space-2);
  border: 1px solid var(--color-danger);
  border-radius: var(--radius-control);
  background: var(--color-danger-subtle);
  color: var(--color-danger);
}

.sheetFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding-block-start: var(--space-3);
}

.sheetFooter a {
  display: inline-flex;
  align-items: center;
  min-height: var(--target-min);
  color: var(--color-text-secondary);
}

.boot {
  display: grid;
  place-content: center;
  justify-items: center;
  gap: var(--space-2);
  min-height: 100vh;
  min-height: 100dvh;
  padding: var(--space-3);
  background: var(--color-canvas);
  color: var(--color-text-secondary);
  text-align: center;
}

.bootMark {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--color-accent);
  color: #fff;
  box-shadow: var(--shadow-surface);
}

.bootWordmark {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 1.25rem;
  font-weight: 800;
}

.boot p {
  margin-block: 0;
}

.bootError {
  display: grid;
  justify-items: center;
  gap: var(--space-2);
}

@media (max-width: 900px) {
  .shell,
  .shell[data-navigation-collapsed="true"] {
    grid-template:
      "mobile-header" auto
      "main" minmax(0, 1fr) /
      minmax(0, 1fr);
  }

  .rail {
    display: none;
  }
  .desktopNavigationToggle {
    display: none;
  }

  .mobileHeader {
    grid-area: mobile-header;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-2);
    min-width: 0;
    min-height: calc(var(--shell-local-header-height) + var(--shell-safe-top));
    padding-block-start: var(--shell-safe-top);
    padding-inline: max(var(--space-2), var(--shell-safe-left)) max(var(--space-2), var(--shell-safe-right));
    border-block-end: 1px solid var(--color-hairline);
    background: var(--color-surface);
  }

  .mobileBrand {
    min-width: 0;
    font-size: 1rem;
  }

  .mobileBrand span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .mobileSearchButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex: 0 1 11rem;
    min-width: var(--target-min);
    min-height: var(--target-min);
    padding-inline: 10px;
    border: 1px solid var(--color-boundary);
    border-radius: var(--radius-control);
    background: var(--color-surface-raised);
    color: var(--color-text-primary);
    font: inherit;
    font-size: 0.75rem;
    font-weight: 700;
    cursor: pointer;
  }

  .mobileSearchButton:hover {
    border-color: var(--color-accent);
    background: var(--color-accent-subtle);
  }

  .mobileSearchButton span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .main {
    grid-area: main;
    min-height: 0;
    padding: var(--space-2);
    padding-inline-start: max(var(--space-2), var(--shell-safe-left));
    padding-inline-end: max(var(--space-2), var(--shell-safe-right));
    padding-block-end: calc(var(--shell-dock-height) + var(--shell-safe-bottom) + var(--space-3));
  }

  .mobileDock {
    position: fixed;
    z-index: 4;
    inset-inline: 0;
    bottom: 0;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    min-height: calc(var(--shell-dock-height) + var(--shell-safe-bottom));
    padding: 6px max(6px, var(--shell-safe-right)) var(--shell-safe-bottom) max(6px, var(--shell-safe-left));
    border-block-start: 1px solid var(--color-hairline);
    background: rgb(255 255 255 / 96%);
    box-shadow: 0 -8px 24px rgb(23 26 43 / 6%);
  }

  .dockLink {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 0;
    min-height: var(--target-min);
    padding: 6px 4px;
    border: 1px solid transparent;
    border-radius: var(--radius-control);
    color: var(--color-text-secondary);
    font-size: 0.75rem;
    line-height: 1.15;
    text-align: center;
    text-decoration: none;
  }

  .dockLink[data-active="true"] {
    background: var(--color-accent-subtle);
    color: var(--color-accent);
    font-weight: 750;
  }

  .settingsSheet {
    inset: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
    height: 100dvh;
    max-height: none;
    margin: 0;
    padding-block-end: max(var(--space-3), var(--shell-safe-bottom));
    border: 0;
    border-radius: 0;
  }

  .sheetHeader {
    min-height: calc(var(--shell-local-header-height) + var(--shell-safe-top));
    padding-block-start: max(var(--space-2), var(--shell-safe-top));
    padding-inline: max(var(--space-2), var(--shell-safe-left)) max(var(--space-2), var(--shell-safe-right));
  }

  .sheetHeader h2 {
    font-size: 1.25rem;
  }

  .settingsSection,
  .simulationPanel,
  .sheetFooter {
    margin-inline: max(var(--space-2), var(--shell-safe-left)) max(var(--space-2), var(--shell-safe-right));
  }

  .sheetFooter {
    align-items: stretch;
    flex-direction: column;
  }
}

@media (forced-colors: active) {
  .navLink[data-active="true"],
  .dockLink[data-active="true"],
  .navigationToggle,
  .desktopNavigationToggle,
  .simulationPanel,
  .simulationNotice,
  .simulationExitButton,
  .inlineError {
    border: 2px solid Highlight;
  }

  .navLink[data-active="true"]::before {
    display: none;
  }
}
